import Cookies from "js-cookie";

export const useAuth = () => {
    const currentUser = Cookies.get("currentUser");
    if (currentUser) {
      return true;
    }else{
      return false;
    }
}